import { AggregationType, aggregationHelpKey, aggregationTypeToIcon } from "@dto/fields";
import { TW_AggregationMenuItem, TW_AggregationMenuItemIcon } from "@utils/twClasses";
import { useTranslation } from "react-i18next";

type AggregationMenuItemProps = {
  aggregationType: AggregationType | null;
  onAggregationChange: (aggregationType: AggregationType | null) => void;
  currentAggregation: AggregationType | null;
  /** The column follows a relation: "no aggregation" keys on the linked record. */
  isLinkColumn: boolean;
}

// One aggregation of a column menu: its icon, its label and what it does to the
// rows of the view. `null` is the "default aggregation" (removes the view override).
function AggregationMenuItem({ aggregationType, onAggregationChange, currentAggregation, isLinkColumn }: AggregationMenuItemProps) {
  const { t } = useTranslation();
  const aggregationLabel = t(`field.aggregation.label.${aggregationType}`);
  const aggregationHelp = t(aggregationHelpKey(aggregationType, isLinkColumn));
  return (
    <li onClick={() => onAggregationChange(aggregationType)} className={TW_AggregationMenuItem + (aggregationType === currentAggregation ? " opacity-50 cursor-default" : "")}>
      {aggregationTypeToIcon(aggregationType, TW_AggregationMenuItemIcon)}
      <div>
        <p>{aggregationLabel}</p>
        <p className="text-xs text-gray-500 font-normal">{aggregationHelp}</p>
      </div>
    </li>
  )
}

export default AggregationMenuItem;
